export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
export const COMMIT_SHA = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;
export const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV;
export const GOOGLE_MAPS_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;
export const D2P_BASE_URL = process.env.NEXT_PUBLIC_D2P_BASE_URL;

export const BIFROST_AUTH_HEADER = 'X-Fpuser-Authorization';
export const BIFROST_D2P_SCOPED_AUTH_HEADER = 'X-d2p-Authorization';
export const CLIENT_PUBLIC_KEY_HEADER = 'X-Client-Public-Key';
